import styled from '@emotion/styled'
import { Button } from 'antd'
export default styled(Button)`
  border-color: ${props => props.theme.bluegrey};
`
